import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    height: "inherit",
    width: "inherit",
    "& > .shipeezi-new-grid-component": {
      width: "inherit",
      "& > [data-cy='top-panel']": {
        display: "none",
      },
    },
  },

  tableBodyActionCell: {
    padding: 0,
  },

  tableBodyCell: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    height: "40px",
    lineHeight: 1,
    padding: "12px",
  },

  tableContainer: {
    border: `1px solid ${colors.gray200}`,
    borderRadius: "12px",
    boxShadow: "none",
  },

  tableHeadCell: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    height: "32px",
    lineHeight: 1,
    padding: "8px",
  },

  tableHeadRow: {
    "& th:first-child": {
      paddingLeft: "16px",
    },

    "& th:last-child": {
      paddingRight: "16px",
    },
  },
}));

export default useStyles;
